import React from 'react'
import {Lang} from 'yougile-lang'
import {getWorkflowStage, WorkflowState} from 'yougile-model'
import {FieldsInTask} from './fields-in-task'
import {Header} from './header'
import {NotInWorkflowProps} from './not-in-workflow'
import {StageActions} from './stage-actions'

export interface WorkflowStateProps extends NotInWorkflowProps {
  workflowState: WorkflowState
}

export const InWorkflow = (props: WorkflowStateProps) => {
  const {workflowState, workflows, ...otherProps} = props
  const workflow = workflows.find(w => w.id === workflowState.id)

  if (!workflow) {
    return (
      <div className="mt-8 text-error-old">{Lang.msg.workflow.notFound}</div>
    )
  }
  const stage = getWorkflowStage(workflow, workflowState.stageId)
  if (!stage) {
    return (
      <div className="mt-8 text-error-old">{Lang.msg.workflow.notFound}</div>
    )
  }

  return (
    <div className="mt-8">
      <Header
        {...otherProps}
        workflow={workflow}
        currentStageId={workflowState.stageId}
      />
      <FieldsInTask {...props} workflow={workflow} />
      <StageActions
        {...otherProps}
        workflow={workflow}
        stagePath={['stages', stage.name]}
      />
    </div>
  )
}
